// Read-only preview mode helper.
//
// Source of truth is window.CC_WIDGET_CONFIG.readOnly, set by the host
// page at boot. When true the widget renders a banner and disables all
// SF-write CTAs (Book Fitting, Confirm Appointment, Join Waitlist) so a
// prod-data preview at booking.clubchampion.com can be served pre-cutover
// with zero chance of an accidental write.
//
// Belt + suspenders: the middleware also accepts SF_WRITE_DISABLED=true
// to 403 write endpoints. Don't rely on UI gating alone.

export function isReadOnly(): boolean {
  if (typeof window === 'undefined') return false;
  return window.CC_WIDGET_CONFIG?.readOnly === true;
}
